module.exports = __webpack_public_path__ + "img/cnet.69b1e436.svg";